import React from 'react';
import { Link } from 'react-router-dom';

const BusinessSetup = () => {
    return (
        <div className="bg-gray-50 pt-24 pb-16 px-6 md:px-20">
            <div className="max-w-6xl mx-auto">
                {/* Header Section */}
                <div className="text-center mb-16">
                    <h1 className="text-5xl font-extrabold text-[#0c24da] mb-4">Business Setup Services</h1>
                    <h2 className="text-2xl font-semibold text-gray-700">Start Your Business with Confidence</h2>
                    <p className="mt-4 text-gray-600 max-w-3xl mx-auto">
                        From company registration to HR and compliance, we provide end-to-end business setup services to help entrepreneurs and SMEs establish their businesses efficiently.
                    </p>
                </div>

                {/* Core Services Grid */}
                <div className="grid md:grid-cols-2 gap-8 mb-16">
                    <ServiceSection
                        title="Company Registration"
                        desc="Fast & Hassle-Free Company Incorporation. We help you establish a strong legal foundation."
                        list={['Private Limited & LLP', 'OPC & Partnership', 'Startup Registration', 'Business Name Consultation']}
                    />
                    <ServiceSection
                        title="Legal Documentation"
                        desc="Professional preparation of all necessary contracts, agreements, and licenses."
                        list={['Partnership Agreements', 'Employment Contracts', 'Service Agreements', 'License & Permits']}
                    />
                    <ServiceSection
                        title="Compliance Support"
                        desc="Stay compliant with government regulations to avoid penalties and maintain smooth operations."
                        list={['Annual Compliance', 'License Renewals', 'Tax & Regulatory Support', 'Corporate Records']}
                    />
                    <ServiceSection
                        title="HR & Recruitment"
                        desc="Build the right team with our end-to-end talent acquisition and HR advisory services."
                        list={['Permanent & Contract Hiring', 'Employee Onboarding', 'HR Policy Development', 'Payroll Advisory']}
                    />
                </div>

                {/* Why Choose Us */}
                <div className="bg-white p-10 rounded-3xl shadow-lg border-l-8 border-[#f15a24] mb-16">
                    <h3 className="text-3xl font-bold mb-6">Why Businesses Trust Rajkuruma</h3>
                    <div className="grid md:grid-cols-2 gap-4 text-gray-700">
                        {[
                            "Experienced Business Consultants", "Fast & Transparent Processes",
                            "End-to-End Business Solutions", "Professional Legal & Compliance Support",
                            "Dedicated Customer Assistance", "Affordable Customized Packages"
                        ].map((item, i) => (
                            <p key={i} className="flex items-center font-medium">✅ {item}</p>
                        ))}
                    </div>
                </div>

                {/* Final CTA */}
                <div className="text-center bg-[#1a2b4d] p-12 rounded-3xl text-white">
                    <h3 className="text-3xl font-bold mb-4">Ready to Launch Your Business?</h3>
                    <p className="mb-8">Let our experts handle the paperwork while you grow your vision.</p>
                    <Link to="/enquiry" className="bg-[#f15a24] hover:bg-[#d44d18] px-10 py-4 font-bold rounded-full text-lg transition">BOOK CONSULTATION →</Link>
                </div>
            </div>
        </div>
    );
};

const ServiceSection = ({ title, desc, list }) => (
    <div className="bg-white p-8 rounded-2xl shadow-md hover:shadow-xl transition border-t-4 border-[#0c24da]">
        <h4 className="text-2xl font-bold text-[#0c24da] mb-3">{title}</h4>
        <p className="text-gray-600 mb-4">{desc}</p>
        <ul className="grid grid-cols-2 gap-2">
            {list.map((item, i) => <li key={i} className="text-sm font-medium text-gray-500">▹ {item}</li>)}
        </ul>
    </div>
);

export default BusinessSetup;